import InputSearcher from "./InputSearcher";

export default InputSearcher;